import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";
import {MutasiPartStatus} from "../../../common/Constants";

class MutasiPartFilter extends Component {
    statusOutOptions = [
        {
            label: MutasiPartStatus.WAITING_APPROVAL,
            value: MutasiPartStatus.WAITING_APPROVAL,
        },
        {
            label: MutasiPartStatus.PROCESSED,
            value: MutasiPartStatus.PROCESSED,
        },
        {
            label: MutasiPartStatus.REJECTED_APPROVAL,
            value: MutasiPartStatus.REJECTED_APPROVAL,
        },
    ];

    statusInOptions = [
        {
            label: MutasiPartStatus.PROCESSED,
            value: MutasiPartStatus.PROCESSED,
        },
        {
            label: MutasiPartStatus.RECEIVED,
            value: MutasiPartStatus.RECEIVED,
        },
        {
            label: MutasiPartStatus.REJECTED,
            value: MutasiPartStatus.REJECTED,
        },
        {
            label: MutasiPartStatus.PARTIALLY_RECEIVED,
            value: MutasiPartStatus.PARTIALLY_RECEIVED,
        },
        {
            label: MutasiPartStatus.WAITING_VERIFICATION,
            value: MutasiPartStatus.WAITING_VERIFICATION,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            cabangOptions: [],
            locatorSourceOptions: [],
            locatorTargetOptions: [],
            kodePartOptions: [],
            partOptions: [],
            partName: "",
            ksuName: "",
            hadiahName: "",
            allLocatorBased: [],
        };
    }

    async componentDidMount() {
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {},
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart({
                paramFilters: {},
            }),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: responses[0].data.data.map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
            }));
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.props.mutasiKeluarTab ?
                this.setState((prevValue) => ({
                    ...prevValue,
                    allLocatorBased: responses[1].data.data,
                    locatorSourceOptions: responses[1].data.data.filter(loc => loc.kodeCabang === this.props.state.filterData.sourceCabang?.value)
                        .map((l) => mapToObjectDDL(l.nameLocation, l.nameLocation)
                        ),
                })) :
                this.setState((prevValue) => ({
                    ...prevValue,
                    allLocatorBased: responses[1].data.data,
                    locatorTargetOptions: responses[1].data.data.filter(loc => loc.kodeCabang === this.props.state.filterData.targetCabang?.value)
                        .map((l) => mapToObjectDDL(l.nameLocation, l.nameLocation)
                        ),
                }))
        }

        if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodePartOptions: responses[2].data.data.map((bl) =>
                    mapToObjectDDL(bl.partName, bl.kodePart)
                ),
                partOptions: responses[2].data.data.map((bl) =>
                    mapToObjectDDL(bl.kodePart, bl.kodePart)
                ),
            }));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.state.filterData.kodePart !== this.props.state.filterData.kodePart) {
            this.getPartName();
        }

        if (!prevProps.state.filterVisible && this.props.state.filterVisible) {
            this.getPartName();
        }
    }


    getFilterDataValue(fieldName, fallbackValue = "") {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    }

    getPartName = () => {
        if (R.isNil(this.props.state.filterData.kodePart)) {
            this.setState((prevValue) => ({...prevValue, partName: ""}));
        } else {
            let part = this.state.kodePartOptions.find(kv => R.equals(kv.value, this.props.state.filterData.kodePart.value));
            this.setState((prevValue) => ({...prevValue, partName: part.label}));
        }
    }

    changeCabangAsal = (name, value) => {
        value != null ? this.setState((prevValue) => ({
            ...prevValue,
            locatorSourceOptions: this.state.allLocatorBased.filter(loc => loc.kodeCabang == value.value)
                .map((l) => mapToObjectDDL(l.nameLocation, l.nameLocation))
        })) : this.setState((prevValue) => ({
            ...prevValue,
            locatorSourceOptions: []
        }))
        this.props.onValueChange(name, value)
    }

    changeCabangTujuan = (name, value) => {
        value != null ? this.setState((prevValue) => ({
            ...prevValue,
            locatorTargetOptions: this.state.allLocatorBased.filter(loc => loc.kodeCabang == value.value)
                .map((l) => mapToObjectDDL(l.nameLocation, l.nameLocation))
        })) : this.setState((prevValue) => ({
            ...prevValue,
            locatorTargetOption: []
        }))
        this.props.onValueChange(name, value)
    }

    render() {
        const selectedKodePartValue = this.props.state.filterData?.kodePart?.value;
        const selectedPart = this.state.kodePartOptions.find(p => p.value === selectedKodePartValue);
        const partName = selectedPart?.label || "";
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.state.filterVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <form onSubmit={this.props.onSubmit}>
                            <SimpleInput
                                id="input_text_no_mutasi"
                                name="mutationNumber"
                                label="No. Mutasi"
                                value={this.getFilterDataValue("mutationNumber")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <FlexView column vAlignContent="center">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Tgl. Mutasi:</h4>
                                </div>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        id="select_date_tglmutasi_from"
                                        name="startDate"
                                        nextdate
                                        date={this.getFilterDataValue("startDate")}
                                        maxDate={this.getFilterDataValue("endDate")}
                                        onChange={(value) => this.props.onValueChange("startDate", value)}
                                    />
                                    <span className="margin-bottom-20px">s/d</span>
                                    <SimpleDate
                                        id="select_date_tglmutasi_to"
                                        name="endDate"
                                        nextdate
                                        date={this.getFilterDataValue("endDate")}
                                        onChange={(value) => this.props.onValueChange("endDate", value)}
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleDDL
                                id="select_options_cabang_asal"
                                name="sourceCabang"
                                label="Cabang Asal"
                                box="search"
                                isClearable
                                options={this.state.cabangOptions}
                                value={this.getFilterDataValue("sourceCabang", null)}
                                onChange={(value, {name}) => this.changeCabangAsal(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_locator_asal"
                                name="sourceLocator"
                                label="Locator Asal"
                                box="search"
                                isClearable
                                options={this.state.locatorSourceOptions}
                                value={this.getFilterDataValue("sourceLocator", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_cabang_tujuan"
                                name="targetCabang"
                                label="Cabang Tujuan"
                                box="search"
                                isClearable
                                options={this.state.cabangOptions}
                                value={this.getFilterDataValue("targetCabang", null)}
                                onChange={(value, {name}) => this.changeCabangTujuan(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_locator_tujuan"
                                name="targetLocator"
                                label="Locator Tujuan"
                                box="search"
                                isClearable
                                options={this.state.locatorTargetOptions}
                                value={this.getFilterDataValue("targetLocator", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            {this.props.mutasiKeluarTab ?
                            <SimpleDDL
                                id="select_options_status_out"
                                name="statusSource"
                                label="Status"
                                box="search"
                                isClearable
                                options={this.statusOutOptions}
                                value={this.getFilterDataValue("statusSource", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            :
                            <SimpleDDL
                                id="select_options_status_in"
                                name="statusTarget"
                                label="Status"
                                box="search"
                                isClearable
                                options={this.statusInOptions}
                                value={this.getFilterDataValue("statusTarget", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            }
                           
                            <SimpleDDLWithButton
                                id="select_options_kode_varian"
                                name="kodePart"
                                label="Kode Part"
                                options={this.state.partOptions}
                                value={this.getFilterDataValue("kodePart", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                buttonText={partName}
                            />
                            <SimpleInput
                                id="input_text_qr_code"
                                name="qrCode"
                                label="QR Code"
                                value={this.getFilterDataValue("qrCode")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton type="button" secondary onClick={this.props.onReset}>
                                    Clear
                                </SimpleButton>
                                <SimpleButton type="submit">Terapkan</SimpleButton>
                            </FlexView>
                        </form>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MutasiPartFilter;

class SimpleDDLWithButton extends Component {
    render() {
        return (
            <FlexView vAlignContent="center">
                <SimpleDDL
                    id={this.props.id}
                    name={this.props.name}
                    label={this.props.label}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    options={this.props.options}
                    box="search"
                    isClearable
                    containerclassname="flex-3"
                />
                <SimpleButton
                    className="margin-top-5px flex-1"
                    type="button"
                    onClick={() => {
                        // TODO
                    }}
                >
                    {this.props.buttonText}
                </SimpleButton>
            </FlexView>
        );
    }
}
